import React, { Component } from 'react';
import * as ajax from './../../ajax.js';
import * as lang from './../../lang.js';

import PopUpWindow from './../../components/PopUpWindow';
import { Container, Row, Col, Button } from 'react-bootstrap';

import TextInsertField from './../../components/TextInsertField';
import ComboBoxInsertField from './../../components/ComboBoxInsertField';


class CikkcsoportokView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            cikkcsoportok_id: ''
            , cikkcsoportok_megnevezes: ''
            , cikkcsoportok_megjegyzes_csoport: ''

        }


        this.references = [];
        this.references['cikkcsoportok_id'] = React.createRef();
        this.references['cikkcsoportok_megnevezes'] = React.createRef();
        this.references['cikkcsoportok_megjegyzes_csoport'] = React.createRef();


        this.validators = [];
        this.validators['cikkcsoportok_id'] = {fieldName: 'cikkcsoportok_id', dataType: 'INT', value: this.state.cikkcsoportok_id, mandatory: false, min: null, max: null};
        this.validators['cikkcsoportok_megnevezes'] = {fieldName: 'cikkcsoportok_megnevezes', dataType: 'VARCHAR', value: this.state.cikkcsoportok_megnevezes, mandatory: false, min: null, max: null};
        this.validators['cikkcsoportok_megjegyzes_csoport'] = {fieldName: 'cikkcsoportok_megjegyzes_csoport', dataType: 'VARCHAR', value: this.state.cikkcsoportok_megjegyzes_csoport, mandatory: false, min: null, max: null};


        this.error = false;
        this.msg = "";

        this.load();

    }

    componentDidUpdate(prevProps) {
        if (prevProps.id !== this.props.id) {
            this.load();
        }
    }

    reset = function () {
        this.setState({cikkcsoportok_id: ''
            , cikkcsoportok_megnevezes: ''
            , cikkcsoportok_megjegyzes_csoport: ''
        });
    }

    setBack = function (id, value) {
        this.setState({[id]: value});
    }

    getForm = function () {
        return <Container>
            
            <Row>
                <Col style={{textAlign: 'left'}}>{lang.getTitleBold('cikkcsoportok_megnevezes')}</Col>
                <Col style={{textAlign: 'right'}}>
                <TextInsertField 
                    id={'cikkcsoportok_megnevezes'} 
                    value={this.state.cikkcsoportok_megnevezes}  
                    setBack={this.setBack.bind(this)}
                    reference={this.references['cikkcsoportok_megnevezes']}
                    editable={false}
                    theme={this.props.theme}
                    style={{minWidth:'100%'}}
                    />
                </Col>
            </Row>
            <Row>
                <Col style={{textAlign: 'left'}}>{lang.getTitleBold('cikkcsoportok_megjegyzes_csoport')}</Col>
            </Row>
            <Row>
                <Col style={{textAlign: 'right'}}>
                <TextInsertField 
                    id={'cikkcsoportok_megjegyzes_csoport'} 
                    value={this.state.cikkcsoportok_megjegyzes_csoport}  
                    setBack={this.setBack.bind(this)}
                    reference={this.references['cikkcsoportok_megjegyzes_csoport']}
                    editable={false}
                    theme={this.props.theme}
                    style={{minWidth:'100%'}}
                    />
                </Col>
            </Row>
        
        </Container>
    }

    closeForm = function () {
        this.reset();
        this.props.closeForm();

    }

    transactionSuccess = function () {
        this.error = false;
        this.msg = lang.getTitleBold('transaction_success');
        this.setState({});
    }

    transactionFail = function (errorStringConstant) {
        this.error = true;
        this.msg = lang.getTitleBold(errorStringConstant);
        this.setState({});
    }

    concatAdditionalParams = function () {
        // var stateClone = JSON.parse(JSON.stringify(this.state));
        if (typeof this.props.additionalParams == 'undefined') {
            return this.state;
        }

        if (this.props.additionalParams == null) {
            return this.state;
        }

        var additionalParams = this.props.additionalParams;
        for (var i = 0; i < additionalParams.length; i++) {
            var additionalParam = additionalParams[i];
            for (const property in additionalParam) {
                this.state[property] = additionalParam[property];
            }
        }
        return this.state;
    }

    

    load = function () {
        var validator = ajax.Validator();
        var validForm = validator.formValidator(this.references, this.validators, this.state);
        if (validForm == false) {
            return false;
        }
        var self = this;
        try {
            const url = ajax.getUrlBase() + "modules/Cikkcsoportok/cikkcsoportokFormLoader.php";

            return fetch(url, {
                method: "POST",
                headers: new Headers({"Content-Type": "application/json"}),
                body: JSON.stringify({id: this.props.id})
            }).then(response => {
                if (response.ok) {
                    return response.json().then(response => {
                        if (response.success) {
                            this.setState(response.data[0]);
                        } else {
                            self.transactionFail(response.fail);
                        }

                    }).catch(function (jsonError) {
                        
                        if (null == jsonError) {
                            self.transactionFail('Fetch JSON error');
                            console.error("Fetch JSON error:");
                        } else {
                            self.transactionFail("Fetch JSON error:" + String(jsonError));
                            console.error("Fetch JSON error:" + String(jsonError));
                        }
                    });
                } else {
                    
                    self.transactionFail("HTTP status error:", response.statusText);
                    console.error("HTTP status error:", response.statusText);
                }
            }).catch(function (error) {
                
                self.transactionFail("Fetch error:", error);
                console.error("Fetch error:", error);
                if (null == error) {
                    self.transactionFail("Fetch error:");
                    console.error("Fetch error:");
                } else {
                    self.transactionFail("Fetch error:" + String(error));
                    console.error("Fetch error:" + String(error));
                }
            });
        } catch (ex) {
            
            self.transactionFail("Fetch exception:", String(ex));
            console.error("Fetch exception:", String(ex));
        }
    }

    render() {
        var form = this.getForm();
        var className = (this.props.theme == "true") ? "Dark" : "Light";
        return (<PopUpWindow theme={this.props.theme} style={{maxHeight:350}}>
            <div className={'popupWrapper' + className} id="CikkcsoportokUpdate">
                <div  className={"popupHeader" + className} >
                    <Row>
                        <Col></Col>
                        <Col style={{textAlign: 'center'}}>{lang.getTitleBold('CikkcsoportokView')}</Col>
                        <Col style={{textAlign: 'right'}}>
                        <Button className={'btn-sm'} variant="danger" onClick={this.closeForm.bind(this)}>{lang.getTitle('close')}</Button>
                        </Col>
                    </Row>
                </div>
                <div  className={"popupBody" + className} >{form}</div>
                <div  className={"popupFooter" + className} >
                    <Row>
                        <Col>
                        <div style={{whiteSpace: 'break-spaces'}}>
                            {this.msg} 
                        </div>
        
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                        <Button className={'btn-sm'} id={'save'} onClick={this.closeForm.bind(this)} variant="success" style={{marginTop: '5px'}}>{lang.getTitle('close')}</Button>&nbsp;&nbsp;&nbsp;      
                        </Col>
                    </Row>
                    <Row>
                        <Col style={{minHeight: '10px'}}>
        
                        </Col>
                    </Row>
        
                </div>
            </div>
        </PopUpWindow>);
    }
}

export default CikkcsoportokView;

